import feedback from '@/urls/feedback'
import {
  postFileRequest
} from '@/helper/requests'
import { executeRequest } from '@/store/utils'

const state = {
  feedback: {
    feedback: null,
    loadingFeedback: false,
    error: null
  }
}

const getters = {
  getFeedback: state => state.feedback.feedback,
  getLoadingFeedback: state => state.feedback.loadingFeedback,
  getFeedbackError: state => state.feedback.error
}

const actions = {
  createTicket: ({
    dispatch,
    commit,
    getters
  }, {
    data,
    finalizer = () => {
    },
    catcher = () => {
    }
  }) => {
    /**
     * Создает тикет обратной связи
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {FormData} params.data - данные для создания тикета
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = feedback.FEEDBACK.CREATE_TICKET()
    executeRequest('Feedback', postFileRequest, {
      url,
      data,
      finalizer,
      catcher
    }, {
      dispatch,
      commit,
      getters
    })
  }
}

const mutations = {
  SET_FEEDBACK_LOADING: (state) => {
    /**
     * Включает состояние загрузки обратной связи
     * @param {Object} state - состояние хранилища
     */
    state.feedback.loadingFeedback = true
  },
  SET_FEEDBACK_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки обратной связи
     * @param {Object} state - состояние хранилища
     */
    state.feedback.loadingFeedback = false
  },
  SAVE_FEEDBACK_ERROR: (state, error) => {
    /**
     * Сохраняет ошибки при работе с обратной связью
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.feedback.error = error
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
